<template>
  <BasePage :name="'Создание ' + (this.workObjectType ? this.workObjectType.entity_view_name : '-')">
    <div class="object-form">
        <div v-if="Object.keys(this.$route.query).length > 0">
            Обнаружены GET Параметры! {{ this.$route.query }} <br><br>
        </div>
        <ChangeObjectForm v-if="this.workObjectType != null"
                 :raw_fields="this.workObjectType.fields"
                 :raw_actions="this.workObjectType.actions"
                 @completeFormAction="this.completedForm"
        />
    </div>
  </BasePage>
</template>

<script>
import BasePage from '@/components/navigation/BasePage';
import getObjectTypeInfo from '@/assets/dataSources/admin/getObjectTypeInfo';
import createObjectRequest from '@/assets/dataSources/admin/createObjectRequest';
import ChangeObjectForm from '@/views/related_pages/adminLayout/forms/ChangeObjectForm';

export default ({
  name: 'ObjectCreateForm',
  components: {
    BasePage,
    ChangeObjectForm,
  },
  data: () => ({
    workObjectType: null,
  }),
  props: {

  },
  watch: {
    $route(to, from) {
      if (to.path === from.path) {
        return;
      }

      this.rebuildForm();
    },
  },
  methods: {
    completedForm(formData) {
      // const curThis = this;
      // const sendForm = Object.fromEntries(Object.keys(formData).map(
      //     (key) => [
      //       key, [
      //         typeof([]),
      //         typeof({}),
      //       ].includes(typeof(formData[key])) ? JSON.stringify(formData[key]) : formData[key],
      //     ],
      // ));

      createObjectRequest(this.$route.params.objectName, formData, function() {
        // location.href = '/';
      });
    },
    rebuildForm() {
      const curThis = this;

      getObjectTypeInfo(curThis.$route.params.objectName, function(objectTypeInfo) {
        curThis.workObjectType = objectTypeInfo;
      });
    },
  },
  mounted() {
    this.rebuildForm();
  },
  computed: {

  },
});
</script>

<style lang="less">
.object-form {
    margin: 14px;
}
</style>
